import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {deviceTypeActions} from "../../../actions/device-type.actions";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import DeviceTypeTable from "./_components/DeviceTypeTable";
import DeviceTypeForm from "./_forms/DeviceTypeForm";
import {modalActions} from "../../../actions/modal.actions";
import {claimTypes} from "../../../constants/claim.constants";

class DeviceTypePage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(deviceTypeActions.getDeviceTypeList());
    }

    handleOpenCreateModal = () => {
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_device-type'),
            component: <DeviceTypeForm submit={this.handleSubmitCreateForm}/>,
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}));
    };

    handleSubmitCreateForm = (data) => {
        const { dispatch } = this.props;

        delete data['id'];
        dispatch(deviceTypeActions.addDeviceType(data));
    };

    render() {
        const {t, deviceTypeList, user} = this.props;

        const deviceTypeCrud = user[`c_device-type.actions.crud`] || null;

        const breadcrumb = [
            { value: 'device-type', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('device-type') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            { deviceTypeCrud === claimTypes.READ_WRITE ? (
                                <button className="btn btn-success float-right btn-create" onClick={this.handleOpenCreateModal} >
                                    <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                                </button>
                            ) : (<React.Fragment/>) }
                        </div>
                    </div>
                    <div className="card-body">
                        <DeviceTypeTable list={deviceTypeList}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapsStateToProps = (state) => {
    const { deviceTypeList }  = state.deviceTypeReducer;
    const { user } = state.authenticationReducer;
    return {
        deviceTypeList,
        user
    }
};

export default withNamespaces()(connect(mapsStateToProps)(DeviceTypePage));
